import React from 'react';
import { useAppSelector } from '../stores/redux.store';
import { WelcomeSentError } from '../types';
import WelcomeSentInvalidTokenErrorPage from './WelcomeSentInvalidTokenErrorPage';
import WelcomeSentExpiredTokenErrorPage from './WelcomeSentExpiredTokenErrorPage';
import WelcomeSentSuccessPage from './WelcomeSentSuccessPage';
import { usePageStateLoader, fetchPageState } from '../utilities/hooks/useGlobalPageState';
import { AidFrontendFeatureGate } from '../providers/FeatureGates';
import { checkFeatureGateOnceInitialized } from '../utilities/feature-flags/feature-gate';

export async function welcomeSentLoader({ request }: { request: Request }) {
  if (!(await checkFeatureGateOnceInitialized(AidFrontendFeatureGate.USE_STATE_DATA_LOADERS))) {
    return null;
  }

  return await fetchPageState('/rest/signup/welcome/sent/state', request, {
    capabilities: ['capability-group--signup', 'capability-name--signup'],
  });
}

export const WelcomeSentPage = () => {
  usePageStateLoader();

  const error = useAppSelector(state => state.welcomeSent.error);

  if (error === WelcomeSentError.InvalidToken) {
    return <WelcomeSentInvalidTokenErrorPage />;
  } else if (error === WelcomeSentError.ExpiredToken) {
    return <WelcomeSentExpiredTokenErrorPage />;
  } else {
    return <WelcomeSentSuccessPage />;
  }
};

export default WelcomeSentPage;
